module.exports = __webpack_public_path__ + "public/Icons/clock.svg?0b9bab3e";